function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Br\xEDet",
  transform: "translate(-907.000000, -770.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group-7",
  transform: "translate(266.000000, 696.000000)"
}, React.createElement("g", {
  id: "iconmonstr-arrow-25",
  transform: "translate(646.500000, 77.500000) rotate(-270.000000) translate(-646.500000, -77.500000) translate(643.000000, 72.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 1.375 1.4266 0 7 5.5 1.4266 11 0 9.625 4.2 5.5"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/arrow-down.b64d262e.svg";
export { SvgComponent as ReactComponent };